import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../services/content/business.lib.js";
import { SAMEDAYLINK } from "../../../utils/constants.js";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { Suspense } from "react";
import { Popover, Spinner } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
import { FlyoutComposer } from "../../Scaffolding/FlyoutScaffolding/index.js";
import { LinkText } from "./LinkText.js";
import { SameDay } from "./SameDay.js";
import { parseLinkModuleSettings } from "./lib.js";
import { COMPONENT_MAP } from "./types.js";
const COMPONENT_NAME = "UserDefinedLink";
const POPUP_DEV_KEY = "popupVisitExternalLink";
async function UserDefinedLink({
  disablePopover,
  insideFlyout = false,
  entry,
  linkListStyle = "text_only",
  locale,
  sx,
  analyticsTitlePrefix
}) {
  var _a, _b, _c, _d;
  if (!entry) {
    console.error("Error in UserDefinedLink, expected `entry` prop.");
    return null;
  }
  const { title, url } = entry.link;
  const Component = COMPONENT_MAP[linkListStyle];
  if (!Component) {
    throw new Error(
      `UserDefinedLink component mapping missing for linkListStyle: ${linkListStyle}`
    );
  }
  const isJustText = !url;
  if (isJustText) {
    return /* @__PURE__ */ jsx(LinkText, { entry });
  }
  const isExternalSite = (_a = entry.link) == null ? void 0 : _a.external_site;
  let externalLinkData;
  if (isExternalSite) {
    const externalLinkModule = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      POPUP_DEV_KEY,
      locale
    );
    if (!externalLinkModule) {
      console.error(
        `Unexpected data from '${ContentType.ModuleSettings}' with developer_key '${POPUP_DEV_KEY}'`
      );
      return null;
    }
    externalLinkData = parseLinkModuleSettings(externalLinkModule);
  }
  const { target } = getLinkBehavior(
    (_b = entry.link) == null ? void 0 : _b.external_site,
    (_c = entry.link) == null ? void 0 : _c.same_tab_domain,
    entry.target_new_same_window_
  );
  const scaffoldingLength = (_d = entry.flyout_scaffolding) == null ? void 0 : _d.length;
  if (!entry.flyout_scaffolding || scaffoldingLength === 0 || disablePopover) {
    return /* @__PURE__ */ jsx(
      Component,
      {
        entry,
        externalLinkData,
        insideFlyout,
        linkListStyle,
        locale,
        sx,
        target
      }
    );
  }
  let analyticsTitle = entry.link.title;
  if (analyticsTitlePrefix) {
    analyticsTitle = `${analyticsTitlePrefix} | ${analyticsTitle}`;
  }
  if (url.includes(SAMEDAYLINK))
    return /* @__PURE__ */ jsx(
      SameDay,
      {
        entry,
        locale,
        analyticsTitle
      }
    );
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [title]
        },
        doNotTrack: entry.disable_third_party_tracking,
        title: analyticsTitle
      },
      children: /* @__PURE__ */ jsx(
        Popover,
        {
          buttonText: title,
          hasArrow: true,
          hasChevronDownIcon: false,
          href: url,
          position: "bottom",
          setFocus: "First Actionable",
          sxButton: { padding: 0 },
          target,
          children: /* @__PURE__ */ jsx(
            Suspense,
            {
              fallback: /* @__PURE__ */ jsx(Spinner, { label: "blue-category", size: "medium" }),
              children: /* @__PURE__ */ jsx(
                FlyoutComposer,
                {
                  entry: entry.flyout_scaffolding,
                  locale,
                  width: entry.flyout_width || "normal"
                }
              )
            }
          )
        }
      )
    }
  );
}
UserDefinedLink.displayName = COMPONENT_NAME;
export {
  UserDefinedLink
};
